let ctx = null;

const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

// Tarayıcılar ilk dokunuştan önce sesi engeller; ilk dokunuşta sesi aç
if (typeof window !== "undefined") {
  const unlock = () => {
    try { getCtx(); } catch (_) {}
  };
  window.addEventListener("pointerdown", unlock, { capture: true });
  window.addEventListener("keydown", unlock, { capture: true });
}

const tone = (c, freq, start, dur) => {
  [1, 2.76].forEach((mult, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq * mult;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(i ? 0.12 : 0.5, start + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(start);
    osc.stop(start + dur);
  });
};

export const isBellOn = () => localStorage.getItem("fb_bell") !== "off";
export const setBellOn = (on) => localStorage.setItem("fb_bell", on ? "on" : "off");

export const ringBell = (force = false) => {
  if (!force && !isBellOn()) return;
  try {
    const c = getCtx();
    const t = c.currentTime + 0.05;
    for (let r = 0; r < 3; r++) {
      tone(c, 1320, t + r * 1.1, 0.9);
      tone(c, 990, t + r * 1.1 + 0.45, 1.0);
    }
  } catch (_) {}
};
